module.exports = __webpack_public_path__ + "static/media/BT.ba4cbaab.svg";